import React from 'react';
import { Package, History, Trash2 } from 'lucide-react';

const OrderManagementControls = ({ 
  onShowOrderHistory, 
  onDeleteAllOrders, 
  orderCount,
  isDeletingAll 
}) => {
  return (
    <div className="dropdown-container">
      <button className="dropdown-toggle">
        <Package size={16} />
        Manage Orders
      </button>
      <div className="dropdown-menu">
        <button
          className="dropdown-item"
          onClick={onShowOrderHistory}
        >
          <History size={16} /> View Order History
        </button>
        <button
          className="dropdown-item"
          onClick={onDeleteAllOrders}
          disabled={isDeletingAll}
        >
          <Trash2 size={16} /> Delete All Orders
        </button>
      </div>
    </div>
  );
};

export default OrderManagementControls;